import { SelectOption } from '@/const/types'

export const phoneTypeOptions: SelectOption[] = [
	{ label: 'Cell', value: 'Cell' },
	{ label: 'Home', value: 'Home' }
]
